import { ComponentPropsWithoutRef } from "react";

export function OutlookIcon(props: ComponentPropsWithoutRef<"svg">) {
  return (
    <svg {...props} data-component="OutlookIcon" viewBox="0 0 56.6934 56.6934">
      <g>
        <path
          d="M38.9577,26.3841l14.6256-9.8605c0-1.1669-1.0887-2.0036-1.7031-2.0036H35.1861v9.7243l3.3984,2.1398   C38.6739,26.41,38.8682,26.4122,38.9577,26.3841z"
          style={{ fill: "#0078D7" }}
        />
        <path
          d="M39.2509,30.0032c0,0-0.5265,0.321-0.9632,0l-3.1016-2.1304h-0.0018v13.2156h15.7551c1.4002,0,2.6458-0.8157,2.6458-2.7616   V20.4542C53.5852,20.4542,38.7262,30.3242,39.2509,30.0032z"
          style={{ fill: "#0078D7" }}
        />
        <path
          d="M18.6389,34.1928c1.04,0,1.8651-0.4688,2.4738-1.4056c0.6087-0.9377,0.9149-2.2394,0.9149-3.9033   c0-1.7345-0.2949-3.0847-0.8871-4.0496c-0.5917-0.9635-1.3999-1.4453-2.4269-1.4453c-1.0569,0-1.899,0.4969-2.521,1.4878   c-0.6217,0.9925-0.9333,2.3051-0.9333,3.9386c0,1.6581,0.3116,2.9686,0.9333,3.9321   C16.8145,33.7132,17.6306,34.1928,18.6389,34.1928z"
          style={{ fill: "#0078D7" }}
        />
        <path
          d="M4.0003,47.6256l28.9409,6.0676V3.9801L4.0003,9.5818V47.6256z M13.9221,22.5941   c1.2267-1.6343,2.8514-2.4515,4.8736-2.4515c1.9098,0,3.4561,0.7804,4.6342,2.3454c1.1799,1.5643,1.7699,3.6248,1.7699,6.1852   c0.0018,2.631-0.6104,4.7521-1.8333,6.3619c-1.2232,1.609-2.8178,2.4161-4.7857,2.4161c-1.9177,0-3.4784-0.7804-4.6865-2.3397   c-1.2063-1.5608-1.8113-3.5924-1.8113-6.0986C12.083,26.3675,12.6957,24.2276,13.9221,22.5941z"
          style={{ fill: "#0078D7" }}
        />
      </g>
    </svg>
  );
}
